<template>
  <div class="settings-container">
    <div class="active-member" :class="`member-${getMemberIndex(activeMember)}`">
      <img :src="require(`@/assets/icons/profile/active-${getMemberIndex(activeMember)}.svg`)" class="logo"/>
      <div class="name">{{ activeMember.firstNamePiiValue }} {{ activeMember.lastNamePiiValue }}</div>
      <div class="email">{{ activeMember.emailPiiValue }}</div>
      <div>{{ formatPhoneNumber(activeMember.phoneNumberPiiValue) }}</div>
      <div class="personal-settings-container">
        <div class="link" @click="navigate('PersonalInformation')">
          <span>פרטים אישיים</span>
          <img class="icon" :src="require('@/assets/icons/white-pencil.svg')"/>
        </div>
      </div>
    </div>
    <div class="other-members-container" v-if="hasOtherMembers">
      <div class="subtitle">לקוחות במנוי</div>
      <div class="other-member" v-for="member of otherMembers" :key="member.phoneNumberPiiValue">
        <div class="logo-container">
          <img :src="require(`@/assets/icons/profile/secondary-${getMemberIndex(member)}.svg`)" class="logo"/>
        </div>
        <div class="details">
          <div class="name">{{ member.firstNamePiiValue }} {{ member.lastNamePiiValue }}</div>
          <div class="email">{{ member.emailPiiValue }}</div>
          <div>{{ formatPhoneNumber(member.phoneNumberPiiValue) }}</div>
        </div>
      </div>
    </div>
    <div class="menu-items" :class="{ 'has-other-members': hasOtherMembers }">
      <navigation-button @navigate-clicked="navigate('AccountSettings')" button-text="הגדרות מנוי" image-path="nav/subscription-settings.svg"/>
      <navigation-button @navigate-clicked="navigate('CredentialsSettings')" button-text="חשבונות מחוברים" image-path="nav/accounts.svg"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import Segment from '@/Segment';
import phoneNumberUtils from '@/utils/phoneNumber';
import NavigationButton from '@/base-components/app-header/NavigationButton';
import router from '@/router';

export default {
  name: 'Settings',
  components: {
    NavigationButton,
  },
  async created() {
    Segment.trackUserGot('SettingsEntered');
  },
  computed: {
    ...mapState('session', ['activeMember', 'members']),
    otherMembers() {
      return _.differenceBy(this.members, [this.activeMember], member => member.phoneNumberPiiValue);
    },
    hasOtherMembers() {
      return this.otherMembers.length > 0;
    },
  },
  methods: {
    formatPhoneNumber(phoneNumber) {
      return phoneNumberUtils.visualizePhoneNumber(phoneNumber);
    },
    navigate(name) {
      return router.push({ name, query: this.$route.query });
    },
    getMemberIndex(member) {
      return (_.chain(this.members)
        .sortBy(m => m.phoneNumberPiiValue)
        .findIndex({ phoneNumberPiiValue: member.phoneNumberPiiValue })
        .value() + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~base-ui/src/scss/riseup-colors";

.settings-container {
  font-family: SimplerPro;
  .active-member {
    padding: 30px 0 90px;
    color: $riseup_white;
    text-align: center;
    font-size: 18px;
    &.member-1 {
      background-color: $riseup-blue;
    }
    &.member-2 {
      background-color: $riseup_dark_green;
    }
    &.member-3 {
      background-color: $riseup-orange;
    }
    .logo {
      width: 64px;
      height: 64px;
    }
    .name {
      margin: 24px 0 16px;
      font-family: SimplerProBold;
      font-size: 24px;
    }
    .email {
      margin-bottom: 10px;
    }
    .personal-settings-container {
      display: flex;
      justify-content: center;
      .link {
        margin-top: 24px;
        border: 1px solid $riseup_white;
        border-radius: 8px;
        padding: 10px 32px;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        .icon {
          width: 20px;
          height: 20px;
          position: relative;
          left: -10px;
        }
      }
    }
  }
  .other-members-container {
    position: relative;
    top: -60px;
    margin: 0px 24px;
    background-color: $riseup_white;
    border: 1px solid $riseup_gray_selected;
    box-shadow: 0px 5px 10px rgba(218, 218, 218, 0.5);
    border-radius: 10px;
    .subtitle {
      padding: 30px 48px 16px;
      font-size: 14px;
    }
    .other-member {
      margin: 0 48px 14px;
      padding-bottom: 16px;
      display: flex;
      justify-content: flex-start;
      font-size: 18px;
      color: $riseup_gray_2;
      .logo-container {
        position: absolute;
        right: 18px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding-top: 3px;
        .logo {
          width: 16px;
        }
      }
      .details {
        .name {
          font-size: 18px;
          font-family: SimplerProBold;
          padding-bottom: 14px;
          color: $riseup_black;
        }
        .email {
          margin-bottom: 12px;
        }
      }
      &:not(:last-of-type) {
        border-bottom: solid 1px $riseup-gray_0;
      }
    }
  }
  .menu-items {
    position: relative;
    padding: 0 25px;
    border-top: solid 1px $riseup-gray_0;
    border-bottom: solid 1px $riseup-gray_0;
    &.has-other-members {
      top: -32px;
    }
  }
}
</style>
